import { Client, Plugin } from '@bugsnag/js';

const stripVersionsRegex = /\/(modules\/([^/]+)|app)\/\d+(\.\d+)+\//gi;

export const stripPathVersionsPlugin: Plugin = {
  load: (client: Client) =>
    client.addOnError((event) => {
      const frames = event.errors.reduce((list, error) => [...list, ...error.stacktrace], []);
      frames.forEach((frame) => {
        if (typeof frame?.file !== 'string') {
          return;
        }

        // eslint-disable-next-line no-param-reassign -- need to replace this value in the bugsnag event
        frame.file = frame.file.replace(stripVersionsRegex, '/$1/-version-/');
      });
    }),
};
